import { Injectable } from '@angular/core';

import { Permission } from '@hdms/shared/common-types';
import { FeatureToggleService } from '@hdms/shared/util-core';

import { UserContextService } from '../user/user-context.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  constructor(private readonly userContext: UserContextService, protected readonly ftService: FeatureToggleService) {}

  // TODO: after cleanup of previous implementation of auth management `useGamPermissions` param should be removed and treated as `true`
  checkPermission(key: Permission | string, useGamPermissions = false): boolean {
    if (useGamPermissions && (this.userContext.isAccountManager || !this.userContext.hasData)) {
      return true;
    }

    return (useGamPermissions ? this.userContext.permissions : this.userContext.employeePermissions).includes(key);
  }
}
